import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './CalOMSDischargeAuthPdfInitialState';
import { _setAuthPdfPrint } from './CalOMSDishargeAuthPdfAction';
const STOP_REGION = process.env.REACT_APP_STOP_REGION;

export const getCalOMSDischargePdfForm = createAsyncThunk(
  'stop/getCalOMSDischargePdfForm',
  async (params) => {
    const { pdfUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION,
      },
    };
    const response = await axios
      .get(pdfUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const calOMSDischargePdfSlice = createSlice({
  name: 'stop/calOMSDischargePdfForm',
  initialState,
  reducers: {
    setAuthPdfPrint: _setAuthPdfPrint,
    resetCalOMSDischargePdfForm: () => initialState,
  },
  extraReducers: {
    [getCalOMSDischargePdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setAuthPdfPrint, resetCalOMSDischargePdfForm } =
  calOMSDischargePdfSlice.actions;

export default calOMSDischargePdfSlice.reducer;
